(() => {
  if (window.nunuFaqLoaded) return;
  window.nunuFaqLoaded = true;
  const faqHeading = /faq|questions|q\s*&\s*a|fragen|preguntas|domande|perguntas|vragen|問答|问答|常見問題|常见问题|よくある質問|자주\s*묻는\s*질문/i;
  const questionMark = /[?？]\s*$/;
  function inFaqSection(node) {
    for (let previous = node.previousElementSibling; previous; previous = previous.previousElementSibling) {
      if (!/^H[1-4]$/.test(previous.tagName)) continue;
      if (faqHeading.test(previous.textContent)) return true;
      if (/^H[12]$/.test(previous.tagName)) return false;
    }
    return false;
  }
  function paragraphQuestion(node) {
    return node.tagName === 'P' && node.firstElementChild?.tagName === 'STRONG' &&
      questionMark.test(node.firstElementChild.textContent.trim()) && inFaqSection(node);
  }
  function decorate(details) {
    if (details.classList.contains('nunu-theme-faq')) return;
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    details.removeAttribute('open');
    details.classList.add('nunu-faq', 'nunu-theme-faq');
    const icon = document.createElement('span');
    icon.className = 'nunu-theme-faq__icon';
    icon.setAttribute('aria-hidden', 'true');
    summary.append(icon);
  }
  function fold(question) {
    if (question.closest('details')) return;
    const paragraph = paragraphQuestion(question);
    if (!paragraph && !(/^H[2-4]$/.test(question.tagName) &&
      (questionMark.test(question.textContent.trim()) || (question.tagName !== 'H2' && inFaqSection(question))))) return;
    const following = [];
    for (let node = question.nextElementSibling; node; node = node.nextElementSibling) {
      if (!node.matches('p,ul,ol,table,blockquote,dl') || paragraphQuestion(node)) break;
      if (node.querySelector('a.nunu-product-card') ||
        (node.firstElementChild?.tagName === 'STRONG' && node.querySelector('a[href*="/collections/"],a[href*="/products/"]'))) break;
      following.push(node);
    }
    if (!paragraph && !following.length) return;
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const answer = document.createElement('div');
    answer.className = 'nunu-faq-answer';
    question.before(details);
    details.append(summary, answer);
    if (paragraph) {
      summary.append(question.firstElementChild);
      while (question.firstChild &&
        (question.firstChild.nodeName === 'BR' ||
          (question.firstChild.nodeType === 3 && !question.firstChild.textContent.trim()))) question.firstChild.remove();
      answer.append(question);
    } else {
      summary.append(question);
    }
    following.forEach(node => answer.append(node));
    decorate(details);
  }
  function enhance(scope) {
    const roots = scope.matches?.('[data-nunu-faq-content]') ? [scope] : scope.querySelectorAll('[data-nunu-faq-content]');
    roots.forEach(root => {
      if (root.dataset.nunuFaqReady) return;
      root.dataset.nunuFaqReady = 'true';
      root.querySelectorAll('details').forEach(decorate);
      Array.from(root.querySelectorAll('h2,h3,h4,p')).forEach(fold);
    });
  }
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
